import { FlexUserServiceImpl } from "~/backend/generated/FlexUserService/api/flexUser.service";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import type { TokenData } from "../Authenticator/Authenticator";
import { mapKeysToCamelCase } from "~/utils/mapKeys";

export const validateToken =
    (ctx: ContextManager) =>
    async (accountSid: string, token: string, fingerprint?: string): Promise<TokenData> => {
        const flexUserService = ctx.retrieveInstanceOf(ContextInstance.FlexUserServiceImpl, FlexUserServiceImpl);

        const data = new URLSearchParams({ Token: token });

        if (fingerprint) {
            data.append("Fingerprint", fingerprint);
        }

        const tokenData = await flexUserService.getTokenInfo(accountSid, data.toString(), { token });
        const camelCasedTokenData = mapKeysToCamelCase(tokenData);

        return {
            valid: true, 
            dateExpired: tokenData.expiration, 
            ...camelCasedTokenData
        } as TokenData;
    };
